import request from '@/utils/request'

export function qlChangeCard(data) {
  return request({
    url: '/admin/cardRecord/qlChangeCard',
    method: 'post',
    data: data
  })


}








// WEBPACK FOOTER //
// ./src/api/changeCardRecord.js